<script setup lang="ts">
import { useRoute } from 'vue-router';
import ProgressSpinner from 'primevue/progressspinner';
import { FormBuilder } from '@/components';
import { useFormBuilder } from '@/stores/formBuilder';

const route = useRoute();
const identifier = route.params.identifier;

const formBuilderStore = useFormBuilder();
formBuilderStore.getFormDetails(identifier as string);


</script>

<template>
    <div class="form-builder-contrainer">
        <FormBuilder v-if="formBuilderStore.form && !formBuilderStore.getFormLoader.isLoading"/>
        <div class="form-builder-loader" v-if="formBuilderStore.getFormLoader.isLoading">
            <ProgressSpinner strokeWidth="4" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.form-builder-contrainer {
    height: 100%;
    position: relative;
}
.form-builder-loader {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
